/**
 * Header Section Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly coupled code to the Header Section.
 *
 */

import {register} from '@shopify/theme-sections';

export default register('header', {
  onLoad() {
    const self = this;

    this.setHeaderHeightVar();

    this.navDrawer = this.container.querySelector('.nav-drawer');

    const btnMenuOpen = this.container.querySelector('.nav-toggle');
    btnMenuOpen.addEventListener('click', this.btnMenuClickOpenHandler.bind(this));

    const btnMenuClose = this.container.querySelector('.nav-close');
    btnMenuClose.addEventListener('click', this.btnMenuClickCloseHandler.bind(this));

    this.desktopQuery = window.matchMedia(`(min-width: ${window.theme.breakpoints.large}px)`);

    const desktopQueryCallback = () => {
      this.handleResize();
    };

    // Check for `addEventListener` is required to support iOS and Safari <14.
    if (typeof this.desktopQuery?.addEventListener === 'function') {
      this.desktopQuery.addEventListener('change', desktopQueryCallback.bind(this));
    } else {
      this.desktopQuery.addListener(desktopQueryCallback.bind(this));
    }

    const nav = this.container.querySelector('.nav');
    nav?.addEventListener('mouseenter', this.dispatchCloseSearchEvent.bind(this));

    const searchToggles = document.querySelectorAll('[data-toggle-search]');
    searchToggles.forEach((searchToggle) =>
      searchToggle.addEventListener('click', this.dispatchToggleSearchEvent.bind(this))
    );

    const navOverlay = this.container.querySelector('.fader--nav');
    navOverlay?.addEventListener('click', this.btnMenuClickCloseHandler.bind(this));

    const navLinks = this.container.querySelectorAll('.nav__item--toggle');
    navLinks.forEach((el) => el.addEventListener('click', self.navLinkClickHandler.bind(self)));

    const subNavLinks = this.container.querySelectorAll('.mobile-submenu__item--toggle');
    subNavLinks.forEach((el) => el.addEventListener('click', self.subNavLinkClickHandler.bind(self)));
  },

  setHeaderHeightVar() {
    const headerHeight = this.container.offsetHeight;
    document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
  },

  handleResize() {
    this.setHeaderHeightVar();
    this.btnMenuClickCloseHandler();
    this.collapseDropdown();
  },

  /**
   * Click handler for dropdowns
   */
  collapseDropdown() {
    const activeDropdownLinks = this.container.querySelectorAll('.nav__item.nav__item--has-child.is-expanded');
    const navToggles = this.container.querySelectorAll(
      '.nav__item.nav__item--has-child.is-expanded .nav__item--toggle'
    );

    document.body.classList.remove('dropdown-is-active');

    activeDropdownLinks.forEach((el) => {
      el.classList.remove('is-expanded');
      el.classList.add('is-collapsed');
    });

    navToggles.forEach((el) => el.setAttribute('aria-expanded', false));
  },

  /**
   * .nav-toggle click handler
   */
  btnMenuClickOpenHandler() {
    document.body.classList.add('menu-is-expanded');

    const subMenuParentsExpanded = this.container.querySelectorAll('.nav__item--has-child.is-expanded');

    subMenuParentsExpanded.forEach((el) => {
      el.classList.remove('is-expanded');
      setTimeout(() => el.classList.add('is-collapsed'), 200);
    });

    this.dispatchCloseSearchEvent();
  },

  btnMenuClickCloseHandler() {
    document.body.classList.remove('menu-is-expanded');

    const subMenuParents = this.container.querySelectorAll('.nav__item--has-child.is-expanded');

    subMenuParents.forEach((el) => {
      el.classList.remove('is-expanded');
      el.classList.add('is-collapsed');
    });
  },

  dispatchCloseSearchEvent() {
    const isModalSearchOpen = document.querySelector('html').classList.contains('modal-search-open');
    if (!isModalSearchOpen) return;
    const closeSearchOnNavDrawer = new Event('closeSearch');
    document.dispatchEvent(closeSearchOnNavDrawer);
  },

  dispatchToggleSearchEvent(event) {
    event.preventDefault();
    this.btnMenuClickCloseHandler();
    const toggleSearchOnNavDrawer = new Event('toggleSearch');
    document.dispatchEvent(toggleSearchOnNavDrawer);
  },

  /**
   * .nav__item.has-child > a click handler
   */
  navLinkClickHandler(event) {
    if (this.desktopQuery.matches) return;

    event.preventDefault();

    // Menu item toggle
    const navLinks = this.container.querySelectorAll('.nav__item--toggle');
    const navItem = event.currentTarget.parentElement;
    const thisNavItem = event.currentTarget;

    if (navItem.classList.contains('is-expanded')) {
      thisNavItem.setAttribute('aria-expanded', false);
      navItem.classList.remove('is-expanded');
      setTimeout(() => navItem.classList.add('is-collapsed'), 200);
      document.body.classList.remove('dropdown-is-active');
    } else {
      const expandDropdown = () => {
        navLinks.forEach((el) => el.parentElement.classList.remove('is-expanded'));
        navLinks.forEach((el) => el.parentElement.classList.add('is-collapsed'));
        navLinks.forEach((el) => el.setAttribute('aria-expanded', false));
        navItem.classList.remove('is-collapsed');
        navItem.classList.add('is-expanded');
        document.body.classList.add('dropdown-is-active');
        thisNavItem.setAttribute('aria-expanded', true);
      };

      expandDropdown();
    }

    return true;
  },

  subNavLinkClickHandler(event) {
    if (this.desktopQuery.matches) return;

    event.preventDefault();

    // Menu item toggle
    const subNavLinks = document.querySelectorAll('.mobile-submenu__item--toggle');
    const subNavItem = event.currentTarget.parentElement;
    const thisSubNavItem = event.currentTarget;

    if (subNavItem.classList.contains('submenu-is-expanded')) {
      thisSubNavItem.setAttribute('aria-expanded', false);
      subNavItem.classList.remove('submenu-is-expanded');
      setTimeout(() => subNavItem.classList.add('submenu-is-collapsed'), 200);
    } else {
      subNavLinks.forEach((el) => el.parentElement.classList.remove('submenu-is-expanded'));
      subNavLinks.forEach((el) => el.parentElement.classList.add('submenu-is-collapsed'));
      subNavLinks.forEach((el) => el.setAttribute('aria-expanded', false));
      subNavItem.classList.remove('submenu-is-collapsed');
      subNavItem.classList.add('submenu-is-expanded');
      thisSubNavItem.setAttribute('aria-expanded', true);
    }

    return true;
  },
});
